export default __webpack_public_path__ + "4bb99c1b45af2dbd9d8ae0f12977d293.svg";